import Fetch from 'utils/fetch';

export const cancelarComposicao = (url, body) => {
  return Fetch.post(url, body).then(({ data }) => data)
}
